import { routerStateReducer as router } from 'redux-router';
import { combineReducers } from 'redux';

import calendar from './calendar';
import editEvent from './editEvent';
import addEventBase from './addEventBase';
import header from './header';
import auth from './auth';
import activate from './activate';
import signup from './signup';
import routerHistory from './routerHistory';
import errorState from './errorState';
import navigation from './navigation';
import modal from './modal';
import apiCache from './apiCache';
import inbox from './inbox';
import schedule from './schedule';
import page from './page';
import myTrips from './myTrips';
import flashMessage from './flashMessage';
import eventDataGroups from './eventDataGroups';
import eventConflictChecks from './eventConflictChecks';

// Updates error message to notify about the failed fetches.
// function errorMessage(state = null, action) {
//   const { type, error } = action;
//
//   if (type === ActionTypes.RESET_ERROR_MESSAGE) {
//     return null;
//   } else if (error) {
//     return action.error;
//   }
//
//   return state;
// }

export default combineReducers({
  calendar,
  editEvent,
  addEventBase,
  header,
  routerHistory,
  auth,
  activate,
  signup,
  errorState,
  navigation,
  modal,
  apiCache,
  inbox,
  schedule,
  page,
  myTrips,
  flashMessage,
  eventDataGroups,
  eventConflictChecks,
  // errorMessage,
  router,
});



// WEBPACK FOOTER //
// ./src/app/reducers/index.js